import { ArrowUpRight, ArrowDownRight, Minus } from "lucide-react";

export const KpiCard = ({ label, value, delta, hint, accent = false, dark = false, testId }) => {
  const showDelta = delta !== null && delta !== undefined;
  const positive = delta > 0;
  const negative = delta < 0;
  const DeltaIcon = positive ? ArrowUpRight : negative ? ArrowDownRight : Minus;
  return (
    <div className={dark ? "kpi-card-dark" : "kpi-card"} data-testid={testId || "kpi-card"}>
      <div className={`text-[10px] uppercase tracking-[0.16em] font-mono ${dark ? "text-slate-400" : "text-slate-500"}`}>
        {label}
      </div>
      <div className={`mt-1.5 sm:mt-2 text-xl sm:text-2xl font-bold font-mono tabular-nums truncate ${accent ? "text-gold" : ""}`}>
        {value}
      </div>
      <div className="mt-1.5 flex items-center gap-1.5 text-[11px] font-medium">
        {showDelta && (
          <span
            className={`inline-flex items-center gap-0.5 ${
              positive ? "text-emerald-600" : negative ? "text-red-600" : "text-slate-500"
            }`}
          >
            <DeltaIcon size={12} />
            <span className="font-mono tabular-nums">{Math.abs(delta).toFixed(1)}%</span>
          </span>
        )}
        {hint && <span className={dark ? "text-slate-400" : "text-slate-500"}>{hint}</span>}
      </div>
    </div>
  );
};
